// extracted by mini-css-extract-plugin
export var attachment = "_ld-a";
export var emailContainer = "_ld-4";
export var emailContentPaddedContainer = "_ld-b";
export var emailHeader = "_ld-6";
export var emailIframe = "_ld-3";
export var emailInfoIcon = "_ld-9";
export var emailShortenedSummary = "_ld-e";
export var infoDropdown = "_ld-0";
export var infoRowBoundedContent = "_ld-d";
export var internal = "_ld-5";
export var merchant = "_ld-8";
export var messageInputContainer = "_ld-h";
export var normal = "_ld-7";
export var replyCard = "_ld-f";
export var subtleButton = "_ld-1";
export var subtleButtonIconContainer = "_ld-2";
export var toggleViewRepliesButton = "_ld-c";
export var wrappingText = "_ld-g";